// Text input sanitizer for the Student Exposure Visit forms.
// Rules:
//   • No leading space.
//   • Only a single space allowed between words (collapse repeats).
// (Trailing space is kept while typing so the user can start the next word;
//  collapse happens as soon as a second consecutive space is typed.)
export function sanitizeText(value: string): string {
  return value
    .replace(/^\s+/, '') // strip leading whitespace
    .replace(/\s{2,}/g, ' '); // collapse multiple spaces to one
}
